import { render, staticRenderFns } from "./authors-list.vue?vue&type=template&id=789c1a2c&scoped=true"
import script from "./authors-list.vue?vue&type=script&lang=js"
export * from "./authors-list.vue?vue&type=script&lang=js"
import style0 from "./authors-list.vue?vue&type=style&index=0&id=789c1a2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789c1a2c",
  null
  
)

export default component.exports